import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartTipPickerBlockConfig } from '@front-platform/content-builder';
import { cartTipPickerBlockResolveConfig } from '@front-platform/content-builder';
import { timer } from 'rxjs';
import { Component, Inject, input } from '@angular/core';
import { debounce, take } from 'rxjs/operators';

import { OrdersService } from '@core/services/orders/orders.service';
import { CartStoreDispatcher } from '@common/dispatchers/cart.dispatcher';

import {
  CART_TIP_PICKER_BLOCK_DATA_SOURCE,
  CartTipPickerBlockDataSource,
} from './cart-tip-picker-block-view-model';
import { provideCartTipPickerBlockDataSource } from './cart-tip-picker-block-data-source.providers';
export interface CartTipPickerBlockRuntimeConfig {}

export type CartTipPickerBlockConfigInput = Partial<
  Omit<CartTipPickerBlockConfig, keyof CartTipPickerBlockRuntimeConfig> &
    CartTipPickerBlockRuntimeConfig
>;
export type CartTipPickerBlockResolvedConfig = Omit<
  CartTipPickerBlockConfig,
  keyof CartTipPickerBlockRuntimeConfig
> &
  Partial<CartTipPickerBlockRuntimeConfig>;
export interface CartTipPickerBlockContract extends ConfigComponentContract<
  CartTipPickerBlockConfigInput,
  CartTipPickerBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-tip-picker-block',
  templateUrl: './cart-tip-picker-block.component.html',
  standalone: false,
  providers: [...provideCartTipPickerBlockDataSource()],
})
export class CartTipPickerBlockComponent implements CartTipPickerBlockContract {
  readonly config = input<CartTipPickerBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartTipPickerBlockConfig,
    CartTipPickerBlockRuntimeConfig
  >(cartTipPickerBlockResolveConfig, () => ({ config: this.config() }));
  get choice1Amount(): number {
    return this.resolvedConfig()['choice_1_amount'] as unknown as number;
  }
  get choice1Unit(): string {
    return this.resolvedConfig()['choice_1_unit'] as unknown as string;
  }
  get choice2Amount(): number {
    return this.resolvedConfig()['choice_2_amount'] as unknown as number;
  }
  get choice2Unit(): string {
    return this.resolvedConfig()['choice_2_unit'] as unknown as string;
  }
  get choice3Amount(): number {
    return this.resolvedConfig()['choice_3_amount'] as unknown as number;
  }
  get choice3Unit(): string {
    return this.resolvedConfig()['choice_3_unit'] as unknown as string;
  }

  protected readonly tipPickerVm$;

  constructor(
    private cartDispatcher: CartStoreDispatcher,
    private readonly ordersService: OrdersService,
    @Inject(CART_TIP_PICKER_BLOCK_DATA_SOURCE)
    blockDataSource: CartTipPickerBlockDataSource,
  ) {
    this.tipPickerVm$ = blockDataSource.vm$;
  }

  onSelectedTip(tip: number): void {
    this.cartDispatcher.updateActive({ tip });
    this.ordersService
      .checkCartIsValid$()
      .pipe(
        take(1),
        debounce(() => timer(1000)),
      )
      .subscribe();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartTipPickerBlockComponent, {
  'keyAliases': {
    'choice1_amount': 'choice_1_amount',
    'choice1_unit': 'choice_1_unit',
    'choice2_amount': 'choice_2_amount',
    'choice2_unit': 'choice_2_unit',
    'choice3_amount': 'choice_3_amount',
    'choice3_unit': 'choice_3_unit',
  },
});
